export { default } from './pagination'
export type { PaginationProps } from './pagination'
